import React, {useCallback, useState} from 'react';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../../../src/appStyles/hooks/theme';

import BottomSheet from '../../../../../../src/components/composites/bottomSheet';
import {Box} from '../../../../../../src/components/core/view';
import {CustomFlatList} from '../../../../../../src/components/core/list';
import DeliveryFailedFooter from './deliveryFailedFooter';
import DeliveyFailedReasonCell from './deliveyFailedReasonCell';
import {Divider} from 'native-base';
import {FailureReason} from '../../../../../../src/driver/types/orderDetails';
import {H3Text} from '../../../../../../src/components/core/text';
import {HomeScreens} from '../../../../../../src/home/navigation/types';
import If from '@buncha/components/conditional/If';
import {MainScreens} from '@buncha/navigation/types';
import {PTextInput} from '../../../../../../src/components/core/input/TextInput';
import {SpinnerComponent} from '../../../../../../src/components/core/loader';
import {TutorialName} from '@buncha/batchDetails/types';
import {navigation} from '../../../../../../src/config/navigation';
import {styles} from './style';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useFinishTutorialForRunner} from '@buncha/home/hooks/Tutorials';
import {useRoute} from '@react-navigation/native';

interface DeliveryFailedBottomSheetProps {
  open: boolean;
  onClose: () => void;
  markOrderAsFailed: (reason: string, notes: string) => void;
}

const DeliveryFailedBottomSheet: React.FC<
  DeliveryFailedBottomSheetProps
> = props => {
  const theme = useColorThemeType('main');
  const mortise = useFontTheme('mortise');
  const {finishTutorialForRunner, tutorialLoading} =
    useFinishTutorialForRunner();
  const [selectedReasonId, setSelectedReasonId] = useState<number>(0);
  const [selectedReason, setSelectedReason] = useState<string>('');
  const [otherReason, setOtherReason] = useState<string>('');
  const routeParams: any = useRoute().params;
  const tutorial = routeParams?.tutorial === 'true';
  const failureOptionsString =
    useAppSelector(
      gState => gState.onboarding.constants?.DRIVER_FAILURE_OPTIONS,
    ) || '{}';
  const faliureOptions = JSON.parse(failureOptionsString);

  let buttonDisabled: boolean =
    selectedReasonId === 0 ||
    (otherReason === '' && selectedReasonId === faliureOptions?.length);

  const changeFailedReason = useCallback(
    (option: FailureReason) => {
      setSelectedReasonId(option?.reasonIndex);
      setSelectedReason(option?.reason);
      if (option?.reasonIndex !== faliureOptions?.length) setOtherReason('');
    },
    [faliureOptions?.length],
  );

  const renderItem = useCallback(
    (item: {item: FailureReason}) => {
      const reasonItem = item?.item;
      return (
        <DeliveyFailedReasonCell
          option={reasonItem}
          changeReason={changeFailedReason}
          selected={reasonItem.reasonIndex === selectedReasonId}
        />
      );
    },
    [changeFailedReason, selectedReasonId],
  );
  const handleItemNotesChange = useCallback((text: string) => {
    setOtherReason(text);
  }, []);

  const markOrderAsFailed = useCallback(async () => {
    if (tutorial) {
      await finishTutorialForRunner(TutorialName.driverGuide);
      return navigation.navigate(MainScreens.Home, {
        screen: HomeScreens.Tutorials,
      });
    }
    props?.markOrderAsFailed(selectedReason, otherReason);
    props?.onClose();
  }, [finishTutorialForRunner, otherReason, props, selectedReason, tutorial]);

  const separator = useCallback(() => <Divider />, []);

  if (tutorialLoading)
    return <SpinnerComponent containerStyle={styles.spinner} />;
  return (
    <BottomSheet open={props?.open} onClose={() => props?.onClose()}>
      <Box style={styles.parentBox}>
        <H3Text
          alignText="left"
          style={{
            color: theme?.text?.blue?.[300],
            fontFamily: mortise?.[700]?.normal,
          }}>
          Reason for Failed Delivery
        </H3Text>
        <CustomFlatList
          scrollEnabled={false}
          data={faliureOptions}
          renderItem={renderItem}
          style={styles?.flatList}
          ItemSeparatorComponent={separator}
        />
        <If condition={selectedReasonId === faliureOptions?.length}>
          <PTextInput
            editable={selectedReasonId === faliureOptions?.length}
            numberOfLines={10}
            placeholder="Please specify any other reason"
            textAlignVertical={'top'}
            multiline={true}
            debounce={false}
            returnKeyType="done"
            style={[styles.input, {color: theme?.text?.blue?.[300]}]}
            textValue={otherReason}
            onChangeText={handleItemNotesChange}
            containerStyle={[
              styles.inputContainer,
              {
                borderColor: theme?.text?.gray?.[100],
              },
            ]}
          />
        </If>
        <Divider />
        <DeliveryFailedFooter
          markAsFailed={markOrderAsFailed}
          disabled={buttonDisabled}
          closeSheet={props?.onClose}
          tutorial={tutorial}
        />
      </Box>
    </BottomSheet>
  );
};

export default React.memo(DeliveryFailedBottomSheet);
